import { createSelector } from '@ngrx/store';
import { DataEntryStore } from '../reducers/data-entry.reducer';
import { getDataEntryFeatureState } from './data-entry.selector';

export const getDataType = createSelector(getDataEntryFeatureState, (state: DataEntryStore) => state.dataType);
